// extracted by mini-css-extract-plugin
export default {"hashtad":"homepage_hashtad__SHLVh"};